import React from 'react';
import FeaturedImage from '../../../components/Atoms/FeaturedImage';
import defaultImageAlt from '../../../utilities/defaultImageAlt';
import sanitize from '../../../utilities/parseHTML/purify';

const featuredImageTransformer = (query) =>
{
    const { featuredImage, cdmfields, title, id } = query.post;
    let imgAlt = defaultImageAlt( title, 'postTitle' );

    if (featuredImage?.node.altText === undefined && cdmfields?.legacymeta?.isQlmigLegacy)
    {
        const parsedAlt = JSON.parse( cdmfields.legacymeta.qlmigArticleImageMetadata )?.alternateText;
        imgAlt = sanitize( parsedAlt ) || defaultImageAlt( title, 'postTitle' );
    }
    else
    {
        imgAlt = sanitize( featuredImage?.node?.altText ) || defaultImageAlt( title, 'postTitle' );
    }
    return (
        <FeaturedImage
            gatsbyFeaturedImage={featuredImage?.node.localFile?.childImageSharp?.data}
            imgPath={cdmfields?.legacymeta?.isQlmigLegacy ? sanitize(cdmfields.legacymeta.qlmigArticleImage) : null}
            imgAlt={imgAlt}
            testId={`article-image-${id}`}
        />
    ) 
}

export default featuredImageTransformer;